const allPaletteVariants = {
    primary: '',
    neutral: '',
    actionPrimary: '',
    actionSecondary: '',
    actionShop: '',
    actionCritical: '',
    favorite: '',
    success: '',
    error: '',
    benefit: '',
    urgency: '',
    customer: '',
    caution: '',
    highlight: '',
    priceSale: '',
    priceRetail: '',
    marketingBrand: '',
    promoPrimary: '',
    penny: '',
    pennyAccents: '',
    vipMember: '',
    vipBlue: '',
    vipGold: '',
    vipPlatinum: ''
};
const paletteFamilies = Object.keys(allPaletteVariants);
const allPaletteShades = {
    1: '',
    2: '',
    3: '',
    4: '',
    5: '',
    6: '',
    7: '',
    8: '',
    9: '',
    10: '',
    11: '',
    12: '',
    13: ''
};
const paletteShades = Object.keys(allPaletteShades);
export { allPaletteShades, allPaletteVariants, paletteFamilies, paletteShades };
